var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmapSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 43,
    viewBox: "0 0 48 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1853 7.52333L23.7696 8.18973L24.3302 7.50335C25.6511 5.88607 27.1689 4.25731 28.857 3.02747C30.544 1.79842 32.3581 0.99889 34.2845 0.965263C41.4335 0.840478 45.9616 7.02972 46.0512 12.1647C46.1497 17.8058 43.0317 23.3936 38.609 28.5287C34.3369 33.4889 28.939 37.9221 24.3498 41.4449C19.6405 38.0846 14.0912 33.8428 9.64858 29.0348C5.04939 24.0573 1.7382 18.5816 1.63972 12.9399C1.55008 7.80446 5.8592 1.46143 13.0084 1.33664L13.0089 1.33663C14.9353 1.303 16.7762 2.03874 18.5051 3.20817C20.2351 4.37834 21.8088 5.95314 23.1853 7.52333Z",
    fill: "#F7CFDA",
    stroke: "black",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapSocial);
export default __webpack_public_path__ + "static/media/roadmap_social.aec869bb4dd16a36adb5834a5135de0c.svg";
export { ForwardRef as ReactComponent };